/*
  Loads an external script by URL, returning a promise that resolves when the script is ready.
  Multiple calls with the same URL share the same <script> tag / promise
 */
const scriptPromises = new Map<string, Promise<void>>();
export const ensureScript = (src: string): Promise<void> => {
    const existing = scriptPromises.get(src);
    if (existing) {
        return existing;
    }
    const promise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            scriptPromises.delete(src);
            reject(new Error(`Failed to load script: ${src}`));
        };
        document.body.appendChild(script);
    });
    scriptPromises.set(src, promise);
    return promise;
};
